export default __webpack_public_path__ + "static/media/Stone-3-with--BG-min.6f5dc2b2.gif";